import React from 'react';
import ZoobbeSelect from '../Global/ZoobbeSelect';

const ConditionBuilder = ({ conditions, conditionFields, operators, onChange, lists, members }) => {
  const addCondition = () => {
    onChange([...conditions, { field: '', operator: 'equals', value: '' }]);
  };

  const updateCondition = (index, key, value) => {
    const updated = [...conditions];
    updated[index] = { ...updated[index], [key]: value };
    // Reset value when field changes
    if (key === 'field') {
      updated[index].value = '';
    }
    onChange(updated);
  };

  const removeCondition = (index) => {
    onChange(conditions.filter((_, i) => i !== index));
  };

  const renderValueInput = (condition, index) => {
    const fieldDef = conditionFields?.find(f => f.key === condition.field);
    if (!fieldDef) return null;

    // No value needed for is_empty/is_not_empty
    if (condition.operator === 'is_empty' || condition.operator === 'is_not_empty') return null;

    switch (fieldDef.type) {
      case 'priority_select':
        return (
          <ZoobbeSelect
            options={[
              { label: 'Select...', value: '' },
              { label: 'Urgent', value: 'Urgent' },
              { label: 'High', value: 'High' },
              { label: 'Normal', value: 'Normal' },
              { label: 'Low', value: 'Low' }
            ]}
            value={condition.value}
            onSelect={(opt) => updateCondition(index, 'value', opt.value)}
          />
        );

      case 'list_select':
        return (
          <ZoobbeSelect
            options={[
              { label: 'Select list...', value: '' },
              ...(lists?.map(list => ({ label: list.title, value: list._id })) || [])
            ]}
            value={condition.value}
            onSelect={(opt) => updateCondition(index, 'value', opt.value)}
          />
        );

      case 'member_select':
        return (
          <ZoobbeSelect
            options={[
              { label: 'Select member...', value: '' },
              ...(members?.map(member => ({
                label: member.name || member.user?.name || member.username || member.user?.username,
                value: member._id || member.user?._id
              })) || [])
            ]}
            value={condition.value}
            onSelect={(opt) => updateCondition(index, 'value', opt.value)}
          />
        );

      case 'boolean':
        return (
          <ZoobbeSelect
            options={[
              { label: 'Yes', value: 'true' },
              { label: 'No', value: 'false' }
            ]}
            value={condition.value || 'true'}
            onSelect={(opt) => updateCondition(index, 'value', opt.value)}
          />
        );

      default:
        return (
          <input
            type="text"
            value={condition.value}
            placeholder="Value..."
            onChange={(e) => updateCondition(index, 'value', e.target.value)}
          />
        );
    }
  };

  const fieldOptions = [
    { label: 'Select field...', value: '' },
    ...(conditionFields?.map(f => ({ label: f.label, value: f.key })) || [])
  ];

  const operatorOptions = operators?.map(op => ({ label: op.label, value: op.value })) || [];

  return (
    <div className="condition-builder">
      {conditions.map((condition, index) => (
        <div key={index} className="condition-row">
          <ZoobbeSelect
            options={fieldOptions}
            value={condition.field}
            onSelect={(opt) => updateCondition(index, 'field', opt.value)}
          />

          <ZoobbeSelect
            options={operatorOptions}
            value={condition.operator}
            onSelect={(opt) => updateCondition(index, 'operator', opt.value)}
          />

          {renderValueInput(condition, index)}

          <button
            className="remove-condition-btn"
            onClick={() => removeCondition(index)}
            title="Remove condition"
          >
            <span className="material-symbols-outlined" style={{ fontSize: 16 }}>close</span>
          </button>
        </div>
      ))}

      <button className="add-condition-btn" onClick={addCondition}>
        <span className="material-symbols-outlined">add</span>
        Add condition
      </button>
    </div>
  );
};

export default ConditionBuilder;
